import { render, staticRenderFns } from "./RecommendStatus.vue?vue&type=template&id=04509be4&scoped=true&"
import script from "./RecommendStatus.vue?vue&type=script&lang=js&"
export * from "./RecommendStatus.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04509be4",
  null
  
)

export default component.exports